import React from 'react';
import {
  ProFormList,
  ProFormSelect,
  ProFormGroup,
  ProFormDependency,
} from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import {
  ENUM_RECIPIENT_TYPE,
  ENUM_ROLE_RECIPIENT_LEVEL,
} from '../../../constants/form';
import SelectRole from '../SelectRole';

const RecipientsInput = ({
  form: _form,
  name,
  label,
  creatorButtonText,
  ...props
}) => {
  return (
    <ProFormList
      name={name}
      label={label}
      creatorButtonProps={{
        creatorButtonText: creatorButtonText,
        position: 'bottom',
        type: 'dashed',
      }}
      copyIconProps={false}
      deleteIconProps={{
        tooltipText: 'delete',
      }}
      {...props}
    >
      <ProFormGroup>
        <ProFormSelect
          width="sm"
          name="type"
          label="Type"
          valueEnum={ENUM_RECIPIENT_TYPE}
          rules={[
            {
              required: true,
            },
          ]}
        />
        <ProFormDependency name={['type']}>
          {({ type }) => {
            return (
              <ProFormGroup>
                <SelectRole
                  width="sm"
                  disabled={type !== 'ROLE'}
                  rules={[
                    {
                      required: type === 'ROLE',
                    },
                  ]}
                />
                <ProFormSelect
                  width="sm"
                  name="level"
                  label="Level"
                  valueEnum={ENUM_ROLE_RECIPIENT_LEVEL}
                  disabled={type !== 'ROLE'}
                  rules={[
                    {
                      required: type === 'ROLE',
                    },
                  ]}
                />
              </ProFormGroup>
            );
          }}
        </ProFormDependency>
      </ProFormGroup>
    </ProFormList>
  );
};

RecipientsInput.defaultProps = {
  name: 'recipients',
  label: 'Recipients',
  creatorButtonText: 'Add a new recipient',
};

RecipientsInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  creatorButtonText: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};

export default RecipientsInput;
